import React from "react";
import { useNavigate } from "react-router-dom";

const BackHeader = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div
      style={{
        backgroundColor: "#2980b9",
        padding: "1rem 2rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      <button
        onClick={handleBack}
        style={{
          backgroundColor: "transparent",
          border: "none",
          color: "white",
          fontSize: "1rem",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          padding: "0.5rem",
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
        <span style={{ marginLeft: "0.5rem" }}>Back</span>
      </button>
    </div>
  );
};

export default BackHeader;
